<template>
  <v-app
    id="inspire"
    class="back"
  >
  
    <v-app-bar
      app
      color="#402c20"
      dark
    >
      <v-spacer></v-spacer>
      <v-btn
        v-on:click="goToHome"
        text
      >
        <span class="mx-1">Home</span>
      </v-btn>

      <v-btn
        v-on:click="gotoPricing"
        text
      >
        <span class="mx-1">Plans</span>
        <v-icon>mdi-money</v-icon>
      </v-btn>

       <v-btn
        text
        v-on:click="gotoContact"
      >
        <span class="mx-1">Contact</span>
      </v-btn>

     
      <v-btn
        href="https://portal.faxhound.com"
        text
      >
        <span class="mr-2">Fax Portal</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>
    <span class="bg"></span>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';

/*
 <!--
      <v-btn
        text
        v-on:click="gotoPDFDrop"
      >
        <span class="mx-1">PDF Drop</span>
        <v-icon>mdi-file</v-icon>
      </v-btn>
      -->

*/

export default {
  name: 'App',
  components: {

  },

  data: () => ({
    //
  }),
  methods: {
    gotoPDFDrop: function() {
      this.$router.push('/pdfdrop');
    },
    goToHome: function() {
      this.$router.push('/');
    },
    gotoPricing: function() {
      this.$router.push('/pricing');
    },
    gotoContact: function() {
      this.$router.push('/contact')
    }
  },
};
</script>

<style scoped>
.back {
  background-image: url(https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260);
  background-size: cover;
}
#inspire {
  background: none;
}
.transparent {
  background-color: rgb(255,0,255,0.5);
}
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: url( 'assets/hound_leaves.jpg') no-repeat center center;
    background-size: cover;
    background-color:white;
    transform: scale(1.1);
  }
</style>
